import React from 'react';
import { Button, Divider } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import type { SSOProvider } from '../../api/auth';

function getProviderIcon(providerId: string) {
  if (providerId === 'google') return <GoogleIcon />;
  if (providerId === 'facebook') return <FacebookIcon />;
  if (providerId === 'twitter') return <XIcon />;
  return undefined;
}

export interface SSOProviderButtonsProps {
  providers: SSOProvider[];
  onSelect: (providerId: string) => void;
  disabled?: boolean;
  testIdPrefix?: string;
}

export function SSOProviderButtons({
  providers,
  onSelect,
  disabled = false,
  testIdPrefix = 'sso',
}: SSOProviderButtonsProps) {
  if (providers.length === 0) return null;

  return (
    <>
      <Divider sx={{ my: 2 }}>or</Divider>
      {providers.map((provider) => (
        <Button
          key={provider.id}
          fullWidth
          variant="outlined"
          startIcon={getProviderIcon(provider.id)}
          onClick={() => onSelect(provider.id)}
          disabled={disabled}
          sx={{ mb: 1 }}
          data-testid={`${testIdPrefix}-${provider.id}`}
        >
          Continue with {provider.displayName}
        </Button>
      ))}
    </>
  );
}
